import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router'; // Импортируйте роутер
import store from './store/store';    // Импортируйте хранилище Vuex
import {
  ORDERS_API_BASE,
  ORDERS_API_CANARY_BASE,
  isCanaryUser,
  canaryManagerCode,
} from '@/config/api';

Vue.config.productionTip = false;

function isOrdersApiUrl(url) {
  return typeof url === 'string' && url.startsWith(ORDERS_API_BASE);
}

function rewriteOrdersUrl(url) {
  if (!isOrdersApiUrl(url)) return url;
  return ORDERS_API_CANARY_BASE + url.slice(ORDERS_API_BASE.length);
}

function resolveAxiosUrl(config) {
  const raw = config.url || '';
  if (/^https?:\/\//i.test(raw)) return raw;
  const base = config.baseURL || '';
  if (!base) return raw;
  return String(base).replace(/\/$/, '') + '/' + String(raw).replace(/^\//, '');
}

// Canary: rewrite ONLY 1akb.by/manager/api → orders-api.
// Do NOT attach X-Manager-Code to unrelated hosts (breaks CORS on bot.vochi.by dial).
axios.interceptors.request.use((config) => {
  const user = store.state && store.state.user;
  if (!isCanaryUser(user)) return config;
  const absolute = resolveAxiosUrl(config);
  if (!isOrdersApiUrl(absolute)) return config;
  config.url = rewriteOrdersUrl(absolute);
  config.baseURL = undefined;
  config.headers = config.headers || {};
  config.headers['X-Manager-Code'] = canaryManagerCode(user);
  return config;
});

const rawFetch = typeof window !== 'undefined' ? window.fetch.bind(window) : null;
if (rawFetch) {
  window.fetch = (input, init) => {
    const user = store.state && store.state.user;
    if (!isCanaryUser(user)) return rawFetch(input, init);
    const url = typeof input === 'string' ? input : input && input.url;
    if (!isOrdersApiUrl(url)) return rawFetch(input, init);

    const rewritten = rewriteOrdersUrl(url);
    const baseHeaders =
      (init && init.headers) ||
      (typeof input !== 'string' && input && input.headers) ||
      undefined;
    const headers = new Headers(baseHeaders || {});
    headers.set('X-Manager-Code', canaryManagerCode(user));

    if (typeof input === 'string') {
      return rawFetch(rewritten, { ...(init || {}), headers });
    }
    // Preserve method/body/credentials from Request; only swap URL + header
    const nextInit = {
      method: input.method,
      headers,
      body: input.body,
      mode: input.mode,
      credentials: input.credentials,
      cache: input.cache,
      redirect: input.redirect,
      referrer: input.referrer,
      integrity: input.integrity,
      ...(init || {}),
    };
    nextInit.headers = headers;
    return rawFetch(rewritten, nextInit);
  };
}

const app = new Vue({
  router,  // Добавляем роутер
  store,   // Добавляем хранилище Vuex
  data() {
    return {
      loading: false // Управляет видимостью глобального лоадера
    };
  },
  render: h => h(App),
}).$mount('#app');

// Добавляем хуки для переходов на уровне маршрутов
router.beforeEach((to, from, next) => {
  app.loading = true; // Показать лоадер перед переходом
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    app.loading = false; // Скрыть лоадер после завершения перехода
  }, 500); // Задержка для плавного перехода (при необходимости)
});
